<script setup lang="ts">
import { type AuthType } from '@glow/shared/features/auth';
import {
  HeroBlock,
  PopularServicesBlock,
  ChooseYourselfBlock,
  AdvantageBlock,
  HowToUseBlock,
  DifferencesBlock,
  ReviewsBlock,
  ReviewPlatformsBlock,
  RecommendBlock,
  FaqBlock,
} from '../components/blocks';
import {
  clientNavigationLinks,
  useClientSteps,
  additionalLinks,
  useWhyItems,
  clientFaqItems,
} from '../content';
import { APP_NAME } from '@glow/shared/lib/constants';
import { useRoutes } from '@glow/shared/lib/routes';

useHead({ title: 'Больше о нас' });

const { getUrl } = useRoutes();
const whyItems = useWhyItems();

const clientSteps = useClientSteps();
const catalogLink = getUrl('partnerCatalog', { type: 'master' });
const profileLink = getUrl('profile');
const offerButton = {
  title: 'Найти своего мастера',
  link: catalogLink,
};

async function onAuthenticate(authType: AuthType) {
  await navigateTo(authType === 'register' ? profileLink : catalogLink);
}
</script>

<template>
  <div>
    <NuxtLayout
      name="landing"
      :navigation-links="clientNavigationLinks"
      :additional-links="additionalLinks"
      :header-main-link="{
        title: 'Найти мастера',
        link: catalogLink,
      }"
      :header-main-link-authenticated-only="false"
      @authenticate="onAuthenticate"
    >
      <HeroBlock class="block" variant="client" />
      <PopularServicesBlock class="block" />
      <ChooseYourselfBlock class="block" />
      <AdvantageBlock id="why" class="block" :items="whyItems">
        <template #title>
          <span>Почему</span>
          пользоваться {{ APP_NAME }}
          <span>удобно</span>
          ?
        </template>
      </AdvantageBlock>
      <HowToUseBlock
        class="block"
        :steps="clientSteps"
        :offer-button="offerButton"
      >
        <template #title>
          <span>Как пользоваться</span>
          сервисом {{ APP_NAME }} для выбора мастера?
        </template>
      </HowToUseBlock>
      <DifferencesBlock class="block" />
      <ReviewsBlock class="block" />
      <!-- <ReviewPlatformsBlock class="block" /> -->
      <RecommendBlock class="block" />
      <FaqBlock class="block" :items="clientFaqItems" />
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.block {
  padding-bottom: stretch-size(375, 1920, 80, 150);
}
</style>
